export default __webpack_public_path__ + "static/private_1-8f73d0de965c55846d7703ae95fbeb93.webp";